/** @format */

import { AddressV3 } from '../address/address-v3.interface';

export interface ShopperAnalytics {
  hashed_identifier: string;
}
export interface Shopper {
  address?: ShopperAddress;
  analytics?: ShopperAnalytics;
  external_key: string;
  external_source: string;
  logged_in?: boolean;
  score_card_image: string;
  scorecard?: string;
  type: string;
}

export interface ShopperAddress extends AddressV3 {
  external_key: string;
}
